import React from "react";
import PropTypes from "prop-types";
import { Checkbox, Grid, InputAdornment, TextField } from "@material-ui/core";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const DisabledCheckbox = styled(Checkbox)`
  padding: 0;
`;

const DisabledFlagField = styled(TextField)`
  .MuiInput-underline:before {
    border-bottom: none;
  }
  .MuiInput-underline:after {
    border-bottom: none;
  }
  .MuiInput-underline:hover:not(.Mui-disabled):before {
    border-bottom: none;
  }
`;

export default function OccurrenceAvailableWebField({
  asGrid,
  margin,
  checked
}) {
  const { t } = useTranslation();
  const isOn = Boolean(checked);
  const field = (
    <DisabledFlagField
      name="availableWeb"
      id="availableWeb"
      label={t("occurrences.dialog.availableWeb")}
      value={
        isOn
          ? t("occurrences.dialog.availableWebYes")
          : t("occurrences.dialog.availableWebNo")
      }
      fullWidth
      margin={margin}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <DisabledCheckbox checked={isOn} disabled />
          </InputAdornment>
        ),
        style: {
          opacity: 0.5,
          pointerEvents: "none"
        }
      }}
    />
  );
  if (!asGrid) {
    return field;
  }
  return (
    <Grid item xs={12}>
      {field}
    </Grid>
  );
}

OccurrenceAvailableWebField.propTypes = {
  asGrid: PropTypes.bool,
  margin: PropTypes.string,
  checked: PropTypes.bool
};

OccurrenceAvailableWebField.defaultProps = {
  asGrid: false,
  margin: undefined,
  checked: false
};
